import { useEffect } from "react";


const LogOut = () => {
    useEffect(() => {
        let mounted = true;
        if (mounted) {
            localStorage.clear();
            window.location.href = '/login';
        }
        return () => mounted = false;
    }, []);
}

export default LogOut;